import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Grid, Modal, Box } from "@mui/material";
import { createAAFF, getAllCommercials } from "../../../services";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { ordenarProvinciasYMunicipios } from "../../../functions/ordenarListas";
import { verificarCorreo, verificarTelefono, verificarCodigoPostal } from "../../../functions/validator/formValidator";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: 800,
  maxHeight: '90vh',
  overflow: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const CrearOficina = ({ opened, handleClose, parentId }) => {
  const { t } = useTranslation(['aaff', 'common']);
  const [aaff, setAaff] = useState({});
  const [comerciales, setComerciales] = useState([]);
  const [listadoMunicipios, setListadoMunicipios] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const response = await getAllCommercials();
    setComerciales(response);
  };

  const limpiarCampos = () => {
    setAaff({});
    setListadoMunicipios([]);
  };

  const handleCancelar = () => {
    limpiarCampos();
    handleClose();
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setAaff({
      ...aaff,
      [evt.target.name]: value,
    });
  };

  const seleccionarMunicipios = (e) => {
    let provincia = "";
    let municipios = [];
    provinces.map(p => {
      if (p.code === e.target.value) {
        provincia = p.name;
      }
    });

    setAaff({
      ...aaff,
      provincia,
    });

    municipalities.map(m => {
      if (m.provCode === e.target.value) {
        municipios.push(m);
      }
    });
    setListadoMunicipios(municipios);
  };

  // Función para generar NIF random con formato: 1 letra + 8 números
  const generarNIFRandom = () => {
    const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const letra = letras.charAt(Math.floor(Math.random() * letras.length));
    const numeros = Math.floor(10000000 + Math.random() * 90000000); // 8 dígitos
    return `${letra}${numeros}`;
  };

  const crearOficina = async (e) => {
    e.preventDefault();

    let emailCorrecto = verificarCorreo(aaff.email);
    let telefonoCorrecto = verificarTelefono(aaff.telefono);
    let codigoPostalCorrecto = verificarCodigoPostal(aaff.codigoPostal);
    let toastInfo = toast.info(t('offices.messages.savingData'));

    let errores = false;

    if (Object.keys(aaff).length === 0) {
      toast.dismiss(toastInfo);
      toast.error(t('offices.messages.emptyData'));
      errores = true;
    } else {
      if (emailCorrecto === false && aaff.email !== undefined) {
        toast.dismiss(toastInfo);
        toast.error(t('offices.messages.incorrectEmail'));
        errores = true;
      }
      if (telefonoCorrecto === false && aaff.telefono !== undefined) {
        toast.dismiss(toastInfo);
        toast.error(t('offices.messages.incorrectPhone'));
        errores = true;
      }

      if (codigoPostalCorrecto === false && aaff.codigoPostal !== undefined) {
        toast.dismiss(toastInfo);
        toast.error(t('offices.messages.incorrectPostalCode'));
        errores = true;
      }

      if (!errores) {
        // Generar NIF random y agregar parent_id
        const nifGenerado = generarNIFRandom();
        const datosOficina = {
          ...aaff,
          nif: nifGenerado,
          parent_id: parentId
        };

        const response = await createAAFF(datosOficina);

        console.log("response.data", response.data);

        if (response.status === 403) {
          toast.update(toastInfo, {
            render: response.data.error[0],
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
        } else if (response.data === "ERROR_CREATE_AAFF") {
          toast.update(toastInfo, {
            render: t('offices.messages.createError'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
        } else if (response.data === "ERROR_AAFF_EXIST") {
          toast.update(toastInfo, {
            render: t('offices.messages.alreadyExists'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
        } else {
          const requiredFields = ['email'];
          let campoVacio = false;
          for (const field of requiredFields) {
            if (!datosOficina[field]) {
              campoVacio = true;
              break;
            }
          }

          if (campoVacio) {
            toast.update(toastInfo, {
              render: t('offices.messages.requiredField'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          } else {
            if (response.status === 200) {
              toast.update(toastInfo, {
                render: t('offices.messages.createdSuccess'),
                type: toast.TYPE.SUCCESS,
                autoClose: true,
              });
              setTimeout(() => {
                limpiarCampos();
                handleClose();
              }, 2000);
            }
          }
        }
      }
    }
  };

  return (
    <Modal
      open={opened}
      onClose={handleCancelar}
      aria-labelledby="modal-crear-oficina"
      aria-describedby="modal-crear-nueva-oficina"
    >
      <Box sx={style}>
        <div className="gridHead" style={{ marginBottom: 10 }}>
          {t('offices.createNew')}
        </div>
        <form className="nuevoAAFFForm" onSubmit={crearOficina}>
          <Grid
            container
            spacing={5}
            style={{ marginTop: 0, marginBottom: 20 }}
          >
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                placeholder={t('common:form.businessName')}
                name="razonSocial"
                value={aaff.razonSocial || ''}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="email"
                placeholder={t('common:form.email')}
                name="email"
                value={aaff.email || ''}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="tel"
                placeholder={t('common:form.phone')}
                name="telefono"
                value={aaff.telefono || ''}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                name="provincia"
                onChange={(e) => seleccionarMunicipios(e)}
              >
                <option value={aaff.provincia}>{t('common:form.province')}</option>
                {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <option key={i} value={e.code}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                name="municipio"
                onChange={handleChange}
              >
                <option value={aaff.municipio}>{t('common:filters.municipality')}</option>
                {listadoMunicipios.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <option key={i} value={e.value}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="codigoPostal"
                placeholder={t('common:form.postalCode')}
                name="codigoPostal"
                value={aaff.codigoPostal || ''}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                placeholder={t('offices.form.contactPerson')}
                name="nombreContacto"
                value={aaff.nombreContacto || ''}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="email"
                placeholder={t('offices.form.contactEmail')}
                name="correoContacto"
                value={aaff.correoContacto || ''}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                name="commer_id"
                onChange={handleChange}
              >
                <option value={0}>{t('common:commercials.titleSingular')}</option>
                {comerciales?.map((e, i) => {
                  return (
                    <option key={i} value={e.id}>
                      {e.nombre + " " + e.apellidos}
                    </option>
                  );
                })}
              </select>
            </Grid>
          </Grid>
          <div style={{ display: 'flex', gap: 10, width: '100%' }}>
            <button
              type="button"
              onClick={handleCancelar}
              style={{
                flex: 1,
                padding: '10px 20px',
                backgroundColor: '#888',
                color: 'white',
                border: 'none',
                borderRadius: 5,
                cursor: 'pointer'
              }}
            >
              {t('common:actions.cancel')}
            </button>
            <input
              type="submit"
              value={t('offices.create')}
              style={{
                flex: 1,
                cursor: 'pointer'
              }}
            ></input>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default CrearOficina;
